// src/app/core/guards/auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthManagementService } from '@core/service/auth-management.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthManagementService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    // Si esta autenticado, deja pasar
    if (this.auth.isAuthenticated()) return true;

    // Si no, devuelve UrlTree (no navegues manualmente dentro del guard)
    return this.router.createUrlTree(
      ['/authentication/signin'],
      { queryParams: { redirectTo: state.url } } // opcional: para volver despues
    );
  }
}
